import { TRUCKS_ACTION_TYPES } from '../constants';
import { 
	APP_CONSTANTS,
	GLOBAL_CONSTANTS,
} from '../../../constants';
import { TRUCKS_CONSTANTS } from '../constants';

import { createErrorMessageFromJsonResponse } from '../../../utilities';

import { truckServices } from '../../../api/services';



function requestGetPaginateTruckList(page,limit,sortBy){
	return {
		type: TRUCKS_ACTION_TYPES.GET_PAGINATE_TRUCK_LIST_REQUEST
	}
}

function successGetPaginateTruckList(truckList,page,limit,sortBy){
	return {
		type: TRUCKS_ACTION_TYPES.GET_PAGINATE_TRUCK_LIST_SUCCESS,
		truckList,
		page,
		limit,
		sortBy,
	}
}

function successGetPaginateTruckListAddMore(truckList,page,limit,sortBy){
	return {
		type: TRUCKS_ACTION_TYPES.GET_PAGINATE_TRUCK_LIST_SUCCESS_ADD_MORE,
		truckList,
		page,
		limit,
		sortBy,
	}
}

function failureGetPaginateTruckList(error){
	return {
		type: TRUCKS_ACTION_TYPES.GET_PAGINATE_TRUCK_LIST_FAILURE,
		error,
	}
}

function emptyGetPaginateTruckList(error){
	return {
		type: TRUCKS_ACTION_TYPES.GET_PAGINATE_TRUCK_LIST_EMPTY,
		error,
	}
}

function getPaginateTruckList(page, limit, sortBy){
	return async (dispatch,getState) => {

    	var { token } = getState().auth;
    	if(!token){
    		token = await localStorage.getItem('token');
    	}


    	if(token){
    		try{
    			await dispatch(requestGetPaginateTruckList());

    			//## Get Only Job below available JOb
    			let filterBy = {
    				
    			}

    			let select = null;

    			if(!sortBy){
    				sortBy = APP_CONSTANTS.DEFAULT_PAGINATION_SORT_BY;
    			}

    			let payload = {
    				page: page,
    				limit: limit,
    				filterBy: filterBy,
    				sortBy: sortBy,
    				select: select,
    			}

    			let responseJson = await truckServices.getPaginateTruckList(
						    				token,
						    				payload
						    			);



				if(responseJson){
					if(responseJson.code === GLOBAL_CONSTANTS.CODE_SUCCESS){
						if(responseJson.data){
							// if(page === 0){
							// 	await dispatch(
							// 		successGetPaginateTruckList(
							// 			responseJson.data,
							// 			page,
							// 			limit,
							// 			sortBy,
							// 		)
							// 	);
							// }
							// else if(page > 0){
							// 	await dispatch(
							// 		successGetPaginateTruckListAddMore(
							// 			responseJson.data,
							// 			page,
							// 			limit,
							// 			sortBy,
							// 		)
							// 	);
							// }

							await dispatch(
								successGetPaginateTruckList(
									responseJson.data,
									page,
									limit,
									sortBy,
								)
							);

		                    return responseJson.data;
		                }
		                else{
		                	await dispatch(
		                		emptyGetPaginateTruckList(
		                			TRUCKS_CONSTANTS.ERROR_FAILURE_PAGINATE_TRUCK
		                		)
		                	);
		                	return null;
		                }

					}
					else if(responseJson.response) {

	                    var errMsg = createErrorMessageFromJsonResponse(responseJson.response.data);
	                        await dispatch(
	                        	failureGetPaginateTruckList(errMsg)
	                        );
	                    return null;
	                }
					else if(responseJson.requestError) {
	                    await dispatch(
	                    	failureGetPaginateTruckList(
	                    		responseJson.requestError
	                    	)
						);
	                    return null;
	                }
	                else{
	                    await dispatch(
							failureGetPaginateTruckList(
								TRUCKS_CONSTANTS.ERROR_FAILURE_PAGINATE_TRUCK
							)
						);
		                return null;
	                }
				}
				else{
					await dispatch(
						failureGetPaginateTruckList(
							TRUCKS_CONSTANTS.ERROR_FAILURE_PAGINATE_TRUCK
						)
					);
	                return null;
				}
    		}
    		catch(error){
    			await dispatch(
    				failureGetPaginateTruckList(
    					error.message
    				)
    			);
	    		return null;
    		}
    	}
    	else{
    		await dispatch(
    			failureGetPaginateTruckList(
    				APP_CONSTANTS.ERROR_UNAUTHORIZED_REQUEST
    			)
    		);
	    	return null;
    	}
    }
}


//##-------------------------------------------------------------------------
function requestCountPaginateTruckList(page,limit,sortBy){
	return {
		type: TRUCKS_ACTION_TYPES.COUNT_PAGINATE_TRUCK_LIST_REQUEST
	}
}

function successCountPaginateTruckList(truckListTotalNum){
	return {
		type: TRUCKS_ACTION_TYPES.COUNT_PAGINATE_TRUCK_LIST_SUCCESS,
		truckListTotalNum,
	}
}

function failureCountPaginateTruckList(error){
	return {
		type: TRUCKS_ACTION_TYPES.COUNT_PAGINATE_TRUCK_LIST_FAILURE,
		error,
	}
}

function emptyCountPaginateTruckList(error){
	return {
		type: TRUCKS_ACTION_TYPES.COUNT_PAGINATE_TRUCK_LIST_EMPTY,
		error,
	}
}

function countPaginateTruckList(filterBy){
	return async (dispatch,getState) => {

    	var { token } = getState().auth;
    	if(!token){
    		token = await localStorage.getItem('token');
    	}


    	if(token){
    		try{
    			await dispatch(requestCountPaginateTruckList());

    			//## Get Only Job below available JOb
    			// let filterBy = {
    				
    			// }


    			let responseJson = await truckServices
    			.getCountTotalTruckNum(
					token,						    				
    				filterBy
    			);



				if(responseJson){
					if(responseJson.code === GLOBAL_CONSTANTS.CODE_SUCCESS){
						if(responseJson.data){

							await dispatch(
								successCountPaginateTruckList(
									responseJson.data
								)
							);

							return responseJson.data;
		                }
		                else{
		                	await dispatch(
		                		emptyCountPaginateTruckList(
		                			TRUCKS_CONSTANTS.ERROR_EMPTY_COUNT_PAGINATE_TRUCK
		                		)
		                	);
		                	return null;
		                }

					}
					else if(responseJson.response) {

	                    var errMsg = createErrorMessageFromJsonResponse(responseJson.response.data);
	                        await dispatch(
	                        	failureCountPaginateTruckList(errMsg)
	                        );
	                    return null;
	                }
					else if(responseJson.requestError) {
	                    await dispatch(
	                    	failureCountPaginateTruckList(
	                    		responseJson.requestError
	                    	)
						);
	                    return null;
	                }
	                else{
	                    await dispatch(
							failureCountPaginateTruckList(
								TRUCKS_CONSTANTS.ERROR_FAILURE_COUNT_PAGINATE_TRUCK
							)
						);
		                return null;
	                }
				}
				else{
					await dispatch(
						failureCountPaginateTruckList(
							TRUCKS_CONSTANTS.ERROR_FAILURE_COUNT_PAGINATE_TRUCK
						)
					);
	                return null;
				}
    		}
    		catch(error){
    			await dispatch(failureCountPaginateTruckList(error.message));
	    		return null;
    		}
    	}
    	else{
    		await dispatch(
    			failureCountPaginateTruckList(
    				APP_CONSTANTS.ERROR_UNAUTHORIZED_REQUEST
    			)
    		);
	    	return null;
    	}
    }
}


export const truckListActions = {

	requestGetPaginateTruckList,
	successGetPaginateTruckList,
	successGetPaginateTruckListAddMore,
	failureGetPaginateTruckList,
	emptyGetPaginateTruckList,
	getPaginateTruckList,


	requestCountPaginateTruckList,
	successCountPaginateTruckList,
	failureCountPaginateTruckList,
	emptyCountPaginateTruckList,
	countPaginateTruckList,


}